const USER = {
  MERCHANT_NAME: 'merchant_name'
};

export default USER;
